import { useState } from 'react'
import {
  Switch,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
} from '@material-ui/core'
import { Timer } from '@material-ui/icons'
import ResponseCreateForm from '../ResponseCreate/ResponseCreateForm'
import { func, string, bool } from 'prop-types'

const LanguageSwitch = (props) => {
  const {
    className,
    fromParentNotify,
    fromParentLanguageSelected,
    callbackFromParentEnglishPositiveResponse,
    callbackFromParentEnglishPositiveResponseData,
    callbackFromParentEnglishNegativeResponse,
    callbackFromParentEnglishNegativeResponseData,
    callbackFromParentSpanishPositiveResponse,
    callbackFromParentSpanishPositiveResponseData,
    callbackFromParentSpanishNegativeResponse,
    callbackFromParentSpanishNegativeResponseData,
    fromParentEnglishPositiveResponseData,
    fromParentEnglishNegativeResponseData,
    fromParentSpanishPositiveResponseData,
    fromParentSpanishNegativeResponseData,
    callbackFromParentLanguage,
  } = props
  const [checkedLanguage, setcheckedLanguage] = useState(
    fromParentLanguageSelected,
  )

  const handleChange = (name) => (event) => {
    setcheckedLanguage(event.target.checked)
    callbackFromParentLanguage(event.target.checked)
  }

  const handleLabel = (notifyValue) => {
    if (notifyValue) {
      return 'English Only'
    }
    return 'Spanish and English'
  }

  let responseForm = ''
  responseForm = (
    <ResponseCreateForm
      callbackFromParentEnglishPositiveResponse={
        callbackFromParentEnglishPositiveResponse
      }
      callbackFromParentEnglishPositiveResponseData={
        callbackFromParentEnglishPositiveResponseData
      }
      callbackFromParentEnglishNegativeResponse={
        callbackFromParentEnglishNegativeResponse
      }
      callbackFromParentEnglishNegativeResponseData={
        callbackFromParentEnglishNegativeResponseData
      }
      callbackFromParentSpanishPositiveResponse={
        callbackFromParentSpanishPositiveResponse
      }
      callbackFromParentSpanishPositiveResponseData={
        callbackFromParentSpanishPositiveResponseData
      }
      callbackFromParentSpanishNegativeResponse={
        callbackFromParentSpanishNegativeResponse
      }
      callbackFromParentSpanishNegativeResponseData={
        callbackFromParentSpanishNegativeResponseData
      }
      fromParentNotify={fromParentNotify}
      fromParentLanguageSelectedResponse={checkedLanguage}
      fromParentEnglishPositiveResponseData={
        fromParentEnglishPositiveResponseData
      }
      fromParentEnglishNegativeResponseData={
        fromParentEnglishNegativeResponseData
      }
      fromParentSpanishPositiveResponseData={
        fromParentSpanishPositiveResponseData
      }
      fromParentSpanishNegativeResponseData={
        fromParentSpanishNegativeResponseData
      }
    />
  )

  return (
    <div>
      <List className={className}>
        <ListItem>
          <ListItemIcon>
            <Timer />
          </ListItemIcon>
          <ListItemText primary={handleLabel(checkedLanguage)} />
          <ListItemSecondaryAction>
            <Switch
              checked={checkedLanguage}
              onChange={handleChange('checkedLanguage')}
              value="checkedLanguage"
            />
          </ListItemSecondaryAction>
        </ListItem>
      </List>
      {responseForm}
    </div>
  )
}

export default LanguageSwitch

LanguageSwitch.propTypes = {
  className: string.isRequired,
  fromParentNotify: bool.isRequired,
  callbackFromParentEnglishPositiveResponse: func.isRequired,
  callbackFromParentEnglishPositiveResponseData: func.isRequired,
  callbackFromParentEnglishNegativeResponse: func.isRequired,
  callbackFromParentEnglishNegativeResponseData: func.isRequired,
  callbackFromParentSpanishPositiveResponse: func.isRequired,
  callbackFromParentSpanishPositiveResponseData: func.isRequired,
  callbackFromParentSpanishNegativeResponse: func.isRequired,
  callbackFromParentSpanishNegativeResponseData: func.isRequired,
  fromParentEnglishPositiveResponseData: string.isRequired,
  fromParentEnglishNegativeResponseData: string.isRequired,
  fromParentSpanishPositiveResponseData: string.isRequired,
  fromParentSpanishNegativeResponseData: string.isRequired,
  fromParentLanguageSelected: bool.isRequired,
  callbackFromParentLanguage: func.isRequired,
}
